import { useZones } from '../zones/zones.hook';
import { IEnhancedTableHeadCell, IZone } from '../../models';
import { zonesTableTabsTableColumns } from '../../configs';

type BuildingId = number | null;

type UseZonesProps = {
  buildingId: BuildingId;
};

export const useZonesTableRows = ({
  buildingId,
}: UseZonesProps): [boolean, string[], IEnhancedTableHeadCell[], IZone[]] => {
  const [loading, { all: zones }] = useZones({ buildingId });

  const columnKeys = ['code', 'floorInfo', 'name', 'building', 'status'];

  const columns = zonesTableTabsTableColumns.filter((column) => columnKeys.includes(column.id));

  const rows = zones.sort((a, b) => (a.status < b.status ? -1 : a.status > b.status ? 1 : 0));

  return [loading, columnKeys, columns, rows];
};
